import { render } from "./NewsletterPopup.vue?vue&type=template&id=4b94176b&scoped=true"
import script from "./NewsletterPopup.vue?vue&type=script&lang=js"
export * from "./NewsletterPopup.vue?vue&type=script&lang=js"

import "./NewsletterPopup.vue?vue&type=style&index=0&id=4b94176b&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.31_vue@3.4.31_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b94176b"]])

export default __exports__